import * as React from "react"
import type { SVGProps } from "react"
const SvgVerticalAlignMiddle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22a1 1 0 0 1-.71-.29A1 1 0 0 1 11 21v-3.2l-.93.93a1 1 0 0 1-.67.27q-.4 0-.7-.3a1 1 0 0 1-.27-.7q0-.43.27-.7l2.6-2.6q.14-.15.32-.21a1 1 0 0 1 .76 0q.17.06.32.21l2.63 2.63q.27.27.27.67t-.3.7a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28l-.9-.9V21q0 .42-.29.71-.29.3-.71.29m-7-9a1 1 0 0 1-.71-.29A1 1 0 0 1 4 12q0-.42.29-.71.29-.3.71-.29h14q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zm7-3.43a1 1 0 0 1-.37-.06 1 1 0 0 1-.33-.21L8.68 6.67A1 1 0 0 1 8.4 6q0-.4.3-.7a1 1 0 0 1 .7-.27q.42 0 .7.27l.9.9V3q0-.42.29-.71.29-.3.71-.29.42 0 .71.29.3.29.29.71v3.2l.93-.92Q14.2 5 14.6 5t.7.3q.27.27.27.7t-.27.7l-2.6 2.6q-.14.15-.32.21a1 1 0 0 1-.38.06" />
  </svg>
)
export default SvgVerticalAlignMiddle
